import { useCallback, useEffect } from 'react';

export const useEffectAsync = (asyncFunctions, dependencyArray = []) => {
  const fetchDataCallback = useCallback(async () => {
    await asyncFunctions();
  }, [asyncFunctions]);
  useEffect(() => {
    fetchDataCallback();
  }, dependencyArray);
};

export default useEffectAsync;
